console.log('hit!!!!')
const TreeNav = function () {
  function TreeNav() {
    this.selector = {
      tree_links: document.querySelectorAll(".collection-filter-nav .tree-nav a"),
      maincollection: document.getElementById("main-products-grid__results"),
      maintree: document.querySelector(".collection-filter-nav .tree-nav"),
      mobilefilter: document.querySelector(".products-toolbar__filter-btn"),
      mainfilter: document.querySelector(".main-products-grid__filters"),
      mobilenav: document.querySelector(".main-products-grid__filters .collection-filter-nav"),
      mobilefilterclose: document.querySelector(".tree-nav .drawer__header .drawer__close-btn"),
      mobilefilterproductcount: document.getElementById("mobile-filter-product-count"),
      mobilefiltercollectiontitle: document.getElementById("mobile-filter-collection-title"),
      mobilefiltercollectioncount: document.getElementById("mobile-filter-collection-count"),
    };
    this.state = { lastactive: null, parentClassName: "has-submenu", parentStopClassName: "tree-nav", findLink: null };
    this.load();

  }
  TreeNav.prototype.load = function () {
    var _ = this;
    const collectionUrlParams = new URLSearchParams(window.location.search);
    const collectionCategory = collectionUrlParams.get("category");
    const collectionSubCategory = collectionUrlParams.get("sub-category");
    if (_.selector.tree_links.length > 0) {
      _.selector.tree_links.forEach(async (link) => {
        link.addEventListener("click", async (event) => {
          event.preventDefault();
          const closestLi = event.target.closest("li");
          const hasSubMenu = document.querySelectorAll(".has-submenu");
          const closestUl = closestLi.closest("ul");
          if (closestUl) {
            const currentLiActive = closestLi.closest("ul").querySelectorAll("li.active");
            if (currentLiActive.length > 0) {
              Array.from(currentLiActive).map((li) => {
                li.classList.remove("active");
              });
            }
          }
          if (hasSubMenu.length > 0) {
            hasSubMenu.forEach((submenu) => {
              submenu.classList.remove("active");
            });
          }
          for (let i = 1; i <= 6; i++) {
            var parentSubMenu = event.target.closest(`.parent-${i}`);
            if (parentSubMenu) {
              parentSubMenu.classList.add("active");
            }
          }
          if (!closestLi.classList.contains("has-submenu")) {
            _.state.lastactive = closestLi;
          }
          if (closestLi.classList.contains("active")) {
            const pageLocation = window.location.pathname;
            if (pageLocation.includes("/collections")) {
              console.log('link --->', link.dataset);
              if (document.querySelector('.collection-banner__heading')) {
                document.querySelector('.collection-banner__heading').innerHTML = '';
                document.querySelector('.collection-banner__heading').insertAdjacentHTML("beforeend",link.dataset.collectionTitle);
              } else if(document.querySelector('.section__block')) {
                document.querySelector('.section__block').innerHTML = '';
                document.querySelector('.section__block').insertAdjacentHTML("beforeend",link.dataset.collectionTitle);
              }
              if (document.querySelector('.collection-banner__content .rte.mt-4')) {
                document.querySelector('.collection-banner__content .rte.mt-4').innerHTML = '';
                document.querySelector('.collection-banner__content .rte.mt-4').insertAdjacentHTML("beforeend",link.dataset.collectionDescription);
              } else if (document.querySelector('.collection-banner__content')) {
                const rteDiv = document.createElement("div");
                rteDiv.className = "rte mt-4";
                rteDiv.innerHTML = link.dataset.collectionDescription;
                document.querySelector('.collection-banner__content').appendChild(rteDiv)
              }
            //  window.location.href = link.dataset.collectionUrl;
              await _.sectionrendering(link);
            }
            if (pageLocation.includes("/search")) {
              await _.searchrendering(link);
            }
            _.updateUrl(link); 
          } else {
            const activeLinks = closestLi.querySelectorAll(".active");
            if (activeLinks.length > 0) {
              activeLinks.forEach((link) => {
                link.classList.remove("active");
              });
            }
          }
        });
        if (link.dataset.filterUrl === window.location.pathname) {
          const childElement = link;
          _.findParentsByClassName(childElement, collectionCategory, collectionSubCategory);
        }
      });
    }
    if (_.selector.mobilefilter) {
      _.selector.mobilefilter.addEventListener("click", (event) => {
        _.selector.mainfilter.classList.toggle("lg:js-hidden");
        _.selector.mobilefilter.classList.toggle("is-active");
        if (_.selector.mobilefilter.getAttribute("aria-expanded") === "false") {
          _.selector.mobilefilter.setAttribute("aria-expanded", "true");
        } else {
          _.selector.mobilefilter.setAttribute("aria-expanded", "false");
        }
        _.selector.mobilenav.classList.toggle("active");
      });
    }
    if (_.selector.mobilefilterclose) {
      _.selector.mobilefilterclose.addEventListener("click", () => {
        _.selector.mobilenav.classList.remove("active");
      });
    }
    if (_.selector.mobilefilterproductcount) {
      _.selector.mobilefilterproductcount.addEventListener("click", () => {
        _.selector.mobilenav.classList.remove("active");
      });
    }
  };
  TreeNav.prototype.sectionrendering = async function (link) {
    var _ = this;
    _.selector.maintree.classList.add("disabled");
    _.selector.maincollection.classList.add("loading-container");
    _.selector.maincollection.innerHTML = `<div class="loading-skeleton"></div>`;
    link.classList.add("active");
    const section_url = `/collections/all?section_id=${_.selector.maincollection.dataset.sectionId}&filter.p.tag=${link.dataset.filterHandle}&sort_by=title-ascending`;
    await fetch(section_url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(html, "text/html");
        const specificContainer = htmlDoc.getElementById("main-products-grid__results");
        if (specificContainer) {
          console.log('hello',specificContainer.dataset)
          _.selector.maincollection.innerHTML = specificContainer.innerHTML;
          _.selector.mobilefilterproductcount.innerHTML = `<span class="count_here">${link.dataset.productCount}</span> ${specificContainer.dataset.productFoundText}`;
          _.selector.mobilefiltercollectiontitle.textContent = `${specificContainer.dataset.collectionTitle}`;
          _.selector.mobilefiltercollectioncount.innerHTML = `(<span>${link.dataset.productCount}</span> ${specificContainer.dataset.filteringText})`;
          link.classList.remove("active");
          _.selector.maincollection.classList.remove("loading-container");
          _.selector.maintree.classList.remove("disabled");
          document.dispatchEvent(new CustomEvent("on:bfcache:load-restore"));
//window.location.reload();
        }
      })
      .catch((error) => {
        console.error("Fetch request failed:", error);
        _.selector.maincollection.classList.remove("loading-container");
        _.selector.maintree.classList.remove("disabled");
        link.classList.remove("active");
        document.dispatchEvent(new CustomEvent("on:bfcache:load-restore"));
      });
  };
  TreeNav.prototype.findParentsByClassName = function (childElement, collectionCategory, collectionSubCategory) {
    var _ = this;
    let parent = childElement.parentNode;
    if (!collectionCategory && !collectionSubCategory) {
      childElement.closest("li").classList.add("active");
      while (parent !== null) {
        if (parent.classList.contains(_.state.parentClassName)) {
          parent.classList.add("active");
        }
        if (parent.classList.contains(_.state.parentStopClassName)) {
          break;
        }
        parent = parent.parentNode;
      }
    }
    if (collectionCategory || collectionSubCategory) {
      while (parent !== null) {
        const parentFilterHandle = parent.querySelector("a") ? parent.querySelector("a").dataset.filterHandle : null;
        if (parentFilterHandle === collectionCategory) {
          _.state.findLink = parent;
          parent.classList.add("active");
        }
        if (parentFilterHandle === collectionSubCategory) {
          _.state.findLink = parent;
          parent.classList.add("active");
        }
        if (parent.classList.contains(_.state.parentStopClassName)) {
          const findElement = _.state.findLink.querySelector(`[data-filter-handle=${childElement.dataset.filterHandle}]`);
          findElement && findElement.closest("li").classList.add("active");
          break;
        }
        parent = parent.parentNode;
      }
    }
  };
  TreeNav.prototype.searchrendering = function (link) {
    var _ = this;
    _.selector.maintree.classList.add("disabled");
    _.selector.maincollection.classList.add("loading-container");
    _.selector.maincollection.innerHTML = `<div class="loading-skeleton"></div>`;
    link.classList.add("active");
    const section_url = `search?section_id=${_.selector.maincollection.dataset.sectionId}&type=product,page,article&options[prefix]=last&q=*&filter.p.tag=${link.dataset.filterHandle}?sort_by=price-descending#products-toolbar`;
    fetch(section_url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(html, "text/html");
        const specificContainer = htmlDoc.getElementById("main-products-grid__results");
        if (specificContainer) {
         
          _.selector.maincollection.innerHTML = specificContainer.innerHTML;
          _.selector.mobilefilterproductcount.textContent = `${link.dataset.productCount} ${specificContainer.dataset.productFoundText}`;
          _.selector.mobilefiltercollectiontitle.textContent = `${link.textContent}`;
          _.selector.mobilefiltercollectioncount.textContent = `(${link.dataset.productCount} ${specificContainer.dataset.filteringText})`;
          _.selector.maincollection.classList.remove("loading-container");
          _.selector.maintree.classList.remove("disabled");
          link.classList.remove("active");
        //  window.location.reload();
          document.dispatchEvent(new CustomEvent("on:bfcache:load-restore"));
        }
      })
      .catch((error) => {
        console.error("Fetch request failed:", error);
        _.selector.maincollection.classList.remove("loading-container");
        _.selector.maintree.classList.remove("disabled");
        link.classList.remove("active");
        document.dispatchEvent(new CustomEvent("on:bfcache:load-restore"));
      });
  };
  TreeNav.prototype.updateUrl = function (link) {
    var newUrl = link.href;
    var pageTitle = document.title;
    var sorting = "?sort_by=price-descending#products-toolbar";
   // window.location.href = newUrl;
    history.pushState({ path: newUrl }, pageTitle, newUrl);
    
    const textStartElement = document.querySelector(".custom-select__btn span.text-start");
    if (textStartElement) {
      textStartElement.textContent = "meistverkauft";
    }
    const optionElements = document.querySelectorAll(".custom-select__option");
    optionElements.forEach(function (option) {
      option.removeAttribute("aria-selected");
    });
  };
  TreeNav = new TreeNav();
};
TreeNav();
